module.exports = __webpack_public_path__ + "img/ic_spinner.13a463aa.svg";